import { type FC, useEffect, useState } from "react";
import { determineDataSource } from "../../../Data/DataStores/DataSource";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";

interface Props {
    applyTo: Array<string>;
}

export const DashboardApplyDialog: FC<Props> = ({ applyTo }) => {
    const [ loading, setLoading ] = useState(true);
    const [ error, setError ] = useState(false);
    const [ users, setUsers ] = useState<Array<string>>([]);

    useEffect(() => {
        setError(false);
        setLoading(true);
        setUsers([]);

        determineDataSource()
            .then(async source => {
                const users: Array<string> = [];

                for(const id of applyTo) {
                    const user = await source.users.get(id);

                    users.push(user.name);
                }

                setUsers(users);
                setLoading(false);
            })
            .catch(err => {
                console.log("Error loading users", err);
                setError(true);
                setLoading(false);
            });
    }, [ applyTo ]);

    if(loading) {
        return (
            <div className="w-[300px] p-8">
                <FontAwesomeLight icon="spinner-third" spin /> Loading...
            </div>
        );
    } else if(error) {
        return (
            <div className="w-[300px] p-8">
                <FontAwesomeLight icon="exclamation-triangle" /> Error loading users
            </div>
        );
    }

    return (
        <div>
            <p>
                The following additional users are selected, are you sure you&apos;d like<br /> to save the dashboard to
                these users as well?
            </p>
            <ul>
                {users.map((user, index) => (
                    <li key={index}>
                        {user}
                    </li>
                ))}
            </ul>
        </div>
    );
};
